import React, { PropTypes } from 'react'
import { Field } from 'redux-form'

import './LocationForm.scss'
import LocationInput from './components/LocationInput'
import ProfileMobileNavBar from 'components/ProfileMobileNavBar'
import HomeOfficeSize from './components/HomeOfficeSize'

const LocationForm = (props) => {
  const {
    handleSubmit
  } = props

  return (
    <div className='LocationForm navbar-screen'>
      <ProfileMobileNavBar>
        Configurar Servicio
      </ProfileMobileNavBar>

      <div className='LocationForm-content navbar-screen-content'>
        <div className='navbar-screen-container'>
          <form onSubmit={handleSubmit}>
            <div className='LocationForm-Fields'>
              <header className='LocationForm-Header'>
                <h2>Cuéntanos sobre tu domicilio</h2>
                <h4>¿Dónde está? ¿Qué tan grande es?</h4>
              </header>

              <fieldset>
                <legend>Colonia</legend>
                <Field
                  name='location'
                  component={LocationInput} />
              </fieldset>

              <HomeOfficeSize />
            </div>

            <footer className='LocationForm-Footer'>
              <button type='submit' className='btn btn-default btn-block btn-lg'>Continuar</button>
            </footer>

          </form>
        </div>
      </div>
    </div>
  )
}
LocationForm.displayName = 'LocationForm'
LocationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired
}

export default LocationForm



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/LocationForm/LocationForm.js